angular.module('admin.politics.index', [
  'security.authorization',
  'services.utility',
  'resources.AdminGroup',
  'resources.AdminUser',
  'services.adminResource',
  'services.search',
  'filters.timeAgo',
  'directives.croppic'
]).config(["$stateProvider", function ($stateProvider) {
  $stateProvider
    .state('admin.politics', {
      url: '/politics',
      title: 'Manage Politics',
      views: {
        'main@': {
          template: require('./admin-politics.tpl.html'),
          controller: 'PoliticsIndexCtrl'
        }
      }
    });
}]).controller('PoliticsIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "AdminUser", function ($scope, $route, $location, $log, utility, adminResource, AdminUser) {

}]);




// WEBPACK FOOTER //
// ./client/src/app/admin/politics/admin-politics.js